// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Block1_wrapper__1yKst"};